// Module
var code = "<p><a href=\"https://www.pheaa.org/loan-default/faq\" target=\"_blank\" class=\"button--isCTALinkWithArrow\">View All Default FAQs</a></p> ";
// Exports
export default code;